import React, { useEffect, useState } from "react";
import { Form, Button, Container, Card } from "react-bootstrap";
import { FaUserCircle } from "react-icons/fa";
import { postAuth } from "./Api/Api";
import cookies from "js-cookie";
import { AuthResponse } from "./Api/models";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
export const Login = () => {
    const navigate = useNavigate();
    const [form, setForm] = useState({
        userName: '',
        password: '',
        ownerName: '',
    })

    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        const auth: AuthResponse = await postAuth(form);
        if (auth?.status === 200 && auth.data.token) {
            cookies.set('loggedAs', 'user')
            cookies.set('Token', auth.data.token)
            navigate('/dashboard')
        } else {
            const errorMessage = auth?.response?.data?.msg || 'Usuario o contraseña incorrectos'
            toast.error(errorMessage)
        }
    }

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    }

    useEffect(() => {
        const loggedAs = cookies.get('loggedAs');
        const token = cookies.get('Token');
        if (token && loggedAs === 'user') {
            navigate('/dashboard')
        }
        if (token && loggedAs === 'admin') {
            navigate('/admin/dashboard')
        }
    }, [navigate])

    return (
        <Container
            className="d-flex justify-content-center align-items-center vh-100"
        >
            <Card style={{ width: "450px", padding: "20px", borderRadius: "12px" }}>
                <div className="text-center mb-4">
                    <FaUserCircle size={50} />
                </div>

                <Form onSubmit={handleSubmit}>
                    <Form.Group className="mb-3">
                        <Form.Label className="text-xs">Nombre Administrador</Form.Label>
                        <Form.Control type="text" placeholder="Escribir administrador" name="ownerName" value={form.ownerName} onChange={handleChange} />
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label className="text-xs">Usuario</Form.Label>
                        <Form.Control type="text" placeholder="Escribir usuario" name="userName" value={form.userName} onChange={handleChange} />
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label className="text-xs">Contraseña</Form.Label>
                        <Form.Control type="password" placeholder="Escribir contraseña" name="password" value={form.password} onChange={handleChange} />
                    </Form.Group>

                    <Button
                        variant="primary"
                        type="submit"
                        className="w-100"
                        style={{ border: "none" }}
                        disabled={!form.ownerName || !form.userName || !form.password}
                    >
                        Iniciar sesión
                    </Button>
                </Form>
            </Card>
        </Container>
    );
};
